import CommandeImpressionPrixHelperController from './commande.impression.helper.controller';

export default {
    bindings: {
        modalInstance: '<'
    },
    template: require('./commande.impression.helper.html'),
    controller: CommandeImpressionPrixHelperController
};
